import ABTesting from './abtesting.js'
import Agreements from './agreements.js'
import Auth from './authentification.js'
import Feedback from './feedback.js'
import Newsletters from './newsletters.js'
import Notifications from './notifications.js'
import Partners from './partners.js'
import Provider from './provider.js'
import Server from './server.js'
import Sponsorship from './sponsorship.js'
import User from './user.js'

export default {

    abtesting: ABTesting,

    agreements: Agreements,

    auth: Auth,

    feedback: Feedback,

    user: User,

    newsletters: Newsletters,

    notifications: Notifications,

    partners: Partners,

    provider: Provider,

    sponsorship: Sponsorship,

    server: Server

}
